import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import {
  currentAppDefinitionEntityId,
  currentAppVersion,
} from 'app/developer-v3/selectors';

import MainContent from './MainContent';

const mapStateToProps = state => {
  const currentAppDefinitionId = currentAppDefinitionEntityId(state);
  const currentVersion = currentAppVersion(state);
  const definitionForRoute = currentAppDefinitionId
    ? CliAppDefinition.selectors.all.entity(currentAppDefinitionId, state)
    : null;
  const isDefinitionLoading = CliAppDefinition.selectors.all.isLoading(state);
  const hasLoadedDefinitions =
    CliAppDefinition.selectors.all.hasLoaded(state) ||
    CliAppDefinition.selectors.all.isFailure(state);

  return {
    appHasLoaded: hasLoadedDefinitions && definitionForRoute,
    isVersionMissing:
      hasLoadedDefinitions &&
      !isDefinitionLoading &&
      !!currentVersion &&
      (!definitionForRoute ||
        CliAppDefinition.selectors.isNotFound(definitionForRoute)),
  };
};

export default flowRight(connect(mapStateToProps))(MainContent);
